import edge from './Edge.png'
import firefox from './Firefox.png'

const browserImage = {
  edge: edge,
  firefox: firefox,
}

export default browserImage
